import functions from "./functions";
var vwFechProcRazaoItems = {
  async getWithPagination(page, pageSize, sort, sortDesc, priCod, filCod) {
    const start = Date.now();

    var filters = {};
    if (priCod && filCod) {
      filters = {
        PRI_COD: { eq: priCod },
        FIL_COD: { eq: filCod },
      };
    }

    var query = `query vwFechProcRazaoItems($filters:VwFechProcRazaoItemFiltersInput!){
        vwFechProcRazaoItems( sort:"${sort}${
      sortDesc ? ":desc" : ""
    }" filters:$filters ,pagination:{page:${page},pageSize:${pageSize}}){
            data{
              id
              attributes{
                createdAt
                FIL_COD
                PRI_COD
                REF_EXTERNA
                COD_REDUZIDO
                CONTA
                DESC_CONTA
                VL_DEBITO
                VL_CREDITO
                VL_DIFERENCA
              }
            }
        }
      }
    `;
    var graphql = JSON.stringify({
      query,
      variables: {
        filters,
      },
    });
    var url = `${process.env.VUE_APP_STRAPI_URL}/graphql`;
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: graphql,
    })
      .then((res) => {
        if (window.debug) console.log(res);
        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log(json);
        return json;
      });

    const end = Date.now();
    if (window.debug)
      console.log(
        `Execution getWithPagination vwFechProcRazaoItems time: ${
          (end - start) / 1000
        } s`
      );

    const pagination = res?.data?.vwFechProcRazaoItems?.meta?.pagination;
    const values = functions.sanitize(res.data.vwFechProcRazaoItems.data);
    return { values, pagination };
  },

  async post(comment) {
    const start = Date.now();

    var url = `${process.env.VUE_APP_STRAPI_URL}/api/process-comments`;
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: comment }),
    })
      .then((res) => {
        if (window.debug) console.log(res);
        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log(json);
        return json;
      });

    return res;
  },
};

export default vwFechProcRazaoItems;
